import Axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/sim-renamings`

export interface PutSimRenaming {
  name: string | null
  attribute_id: string
}

export interface PutSimRenamingResponse extends PutSimRenaming {
  sim_table_technical_name: string | null
  sim_attribute_technical_name: string | null
}

export async function put(body: PutSimRenaming[]) {
  return Axios.put<{ data: PutSimRenamingResponse[] }>(
    URL,
    { data: body },
    parseAuthenticationHeader()
  )
}
